module.exports = __webpack_public_path__ + "img/cover.b2c7683.png";